import { useEffect, useState } from "react";
import { Button, Form } from "react-bootstrap";
import { Accordion } from "react-bootstrap";
import { AiOutlineCheckCircle } from "react-icons/ai";
import { BsArrowLeft } from "react-icons/bs";
import { useLocation, useNavigate } from "react-router-dom";
import Select from "react-select";
// import "./drag-drop.css";
import {
  IconCloudDownload,
  IconDownload,
  IconExclamationCircle,
  IconPencil,
  IconXboxX,
} from "@tabler/icons-react";
import { PostRequest } from "../../Utils/hooks/ApiHandler";
import useLocalStorageState from "use-local-storage-state";
import { toast } from "sonner";
import { baseURL } from "../../Utils/constants/constant";
import { Loader } from "./Loader";
import { modules } from "./SampleModules";
export const ImportData = () => {
  const location = useLocation();
  const data = location.state || null;
  const navigate = useNavigate();
  const onFilesSelected = () => { };
  const [overwriteColumn, setOverwriteColumn] = useState(null);
  const [currentSelected, setCurrSelected] = useState("skip");
  const [currentStep, setCurrStep] = useState(1);
  const [files, setFiles] = useState([]);
  const [fetchingStatus, setFetchingStatus] = useState(false);
  const [fileHeaders, setFileHeaders] = useState([]);
  const [fieldGroups, setFieldGroups] = useState([]);
  const [values, setValues] = useState();
  const [importResult, setImportResult] = useState(null);
  const [unmappedCount, setUnmappedCount] = useState(0);
  // Session storage and authentication setup
  const [customer, setCustomer] = useLocalStorageState("customer");
  const token = customer?.token?.authorization;
  const rf = customer?.token?.authentication;
  const navigateWithModuleName = () => {
    switch (data?.module_name) {
      case "company":
        return "/company";
      case "contact":
        return "/contacts";
      case "leads":
        return "/leads";
      case "deals":
        return "/deals";
      case "quotation":
        return "/quotations";
      case "purchase_order":
        return "/purchaseOrder";
      case "sales_order":
        return "/salesorder";
      case "invoice":
        return "/salesorder?type=invoice";
      case "invoice_order":
        return "/salesorder?type=invoice";
      case "invoice_order":
        return "/salesorder?type=invoice";
      case "master_product":
        return "/product";
      case "lead_source":
        return "/enquirySource";
      case "department":
        return "/department";
      case "designation":
        return "/designation";
      default:
        return "/";
    }
  };

  useEffect(() => {
    if (data === null || !data.module_name || data.module_name === undefined) {
      navigate(-1);
      return;
    }
    return () => { };
  }, [data]);
  // API headers configuration
  const headers = {
    Authentication: rf,
    Authorization: token,
  };

  const extras = {
    customer,
    setCustomer,
    rf,
    navigate,
  };

  useEffect(() => {
    if (data === null) return;
    setFieldGroups(
      data?.fieldData.map((c) => ({
        key: c.title?.toLowerCase()?.split(" ")?.join("_"),
        title: c.title,
        fields: c.fields,
      }))
    );
  }, []);

  const [mapping, setMapping] = useState({});
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const handleChange = (groupKey, field, selected) => {
    setMapping((prev) => ({
      ...prev,
      [groupKey]: {
        ...(prev[groupKey] || {}),
        [field]: selected,
      },
    }));
  };

  const handleDrop = async (event) => {
    event.preventDefault();
    const droppedFiles = event.dataTransfer.files;

    if (!droppedFiles || droppedFiles.length === 0) return;
    const file = droppedFiles[0];
    setFiles([file]);
  };

  const handleRemoveFile = (index) => {
    setFiles((prevFiles) => prevFiles?.filter((_, i) => i !== index));
  };

  const getSelectedValues = () => {
    return Object.values(mapping)
      .flatMap((group) => Object.values(group || {}))
      ?.filter(Boolean)
      ?.map((item) => item.value);
  };

  const getFilteredOptions = (groupKey, field) => {
    const selectedValues = getSelectedValues();

    const currentValue = mapping[groupKey]?.[field]?.value;

    return fileHeaders?.filter((option) => {
      // allow current value to stay visible
      if (option.value === currentValue) return true;

      // hide already selected values
      return !selectedValues.includes(option.value);
    });
  };

  const handleUploadFile = async (file) => {
    try {
      setFetchingStatus(true);
      if (!file) return;
      const payload = {
        csv_file: file,
      };

      const res = await PostRequest(
        `${baseURL}/csv/upload_file/`,
        payload,
        true,
        { headers },
        extras
      );
      if (res.status === "fail" || res.success === false) {
        toast.warning(res.message)
        setFetchingStatus(false)
        return
      }
      setFetchingStatus(false);
      setFileHeaders(
        res.labels?.map((l) => ({
          value: l,
          label: l,
        }))
      );
      setValues(res.data);
      return true;
    } catch (error) {
      setFetchingStatus(false);
      return false;
    }
  };

  const handleUploadLabels = async () => {
    setLoading(true);
    try {
      // Validate required fields before proceeding
      const newErrors = {};
      let firstErrorFieldId = null;

      for (const group of fieldGroups) {
        for (const field of group.fields) {
          if (field.required) {
            const selected = mapping[group.key]?.[field.id];
            if (!selected) {
              if (!newErrors[group.key]) newErrors[group.key] = {};
              newErrors[group.key][field.id] = true;

              if (!firstErrorFieldId) {
                firstErrorFieldId = `${group.key}-${field.id}`;
              }
            }
          }
        }
      }

      setErrors(newErrors);

      if (firstErrorFieldId) {
        const el = document.getElementById(firstErrorFieldId);
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "center" });
        }
        return;
      }

      if (!data.module_name) return;
      const labels = Object.values(mapping).flatMap((group) =>
        Object.entries(group || {}).map(([field, selected]) => ({
          default_label: field,
          mapped_label: selected?.value || null,
        }))
      );

      const allFieldIds = fieldGroups.flatMap((g) => g.fields.map((f) => f.id));

      setUnmappedCount(
        allFieldIds?.filter((id) => !labels.some((l) => l.default_label === id))
          .length
      );

      const finalLabels = labels;

      const payload = {
        customer_id: customer.customer_details?.customer_id,
        user_login_id: customer.customer_details?.id,
        action:
          data?.module_name === "contact" || data?.module_name === "company"
            ? currentSelected
            : "insert",
        module_name: data?.module_name,
        labels: finalLabels,
        values: values,
      };
      const res = await PostRequest(
        `${baseURL}/csv/verifyImportingData/`,
        payload,
        false,
        { headers },
        extras
      );
      setImportResult(res);
      return res;
    } catch (error) {
      console.error("Upload labels failed", error);
    } finally {
      setLoading(false);
    }
  };

  // Final import function
  const handleFinalImport = async () => {
    setLoading(true);
    try {
      const payload = {
        customer_id: customer.customer_details?.customer_id,
        user_login_id: customer.customer_details?.id,
        module_name: data?.module_name,
        action:
          data?.module_name === "contact" || data?.module_name === "company"
            ? currentSelected
            : "insert",
        labels: importResult?.label || [],
        values: importResult?.importing_data || [],
      };

      const res = await PostRequest(
        `${baseURL}csv/importData/`,
        payload,
        false,
        { headers },
        extras
      );
      toast.success(res.message);
      navigate(navigateWithModuleName());

    } catch (error) {
      console.error("Final import failed", error);
      toast.error("Import failed!");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    onFilesSelected(files);
  }, [files, onFilesSelected]);

  const sanitizeCSVValue = (value) => {
    if (!value) return "";
    return String(value).replace(/,/g, " ");
  };

  const downloadCSV = (filename, headers, data) => {
    const csvContent = [
      headers.join(","), // header row
      ...data.map(
        (row) => row.map((cell) => sanitizeCSVValue(cell)).join(",") // data rows
      ),
    ].join("\n");

    const blob = new Blob([csvContent], {
      type: "text/csv;charset=utf-8;",
    });

    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `${filename}.csv`;
    link.click();
    URL.revokeObjectURL(url);
  };

  function getCompanyRecord(module_name) {
    const module = modules.find((m) => m.name === module_name);
    if (!module) return null;

    downloadCSV(module.fileName, module.headers, module.data);
  }
  const customSelectStyles = {
    control: (base, state) => ({
      ...base,
      minHeight: 38,
      fontSize: 13,
      padding: "0 4px",
      boxShadow: "none",
      border: state.isFocused ? "1px solid #2684FF" : "1px solid #d1d5db",
      "&:hover": {
        borderColor: "#60a5fa",
      },
    }),

    valueContainer: (base) => ({
      ...base,
      padding: "0 4px",
    }),

    input: (base) => ({
      ...base,
      padding: "2px 0",
      margin: 0,
    }),

    placeholder: (base) => ({
      ...base,
      fontSize: 13,
    }),

    singleValue: (base) => ({
      ...base,
      fontSize: 13,
    }),

    indicatorsContainer: (base) => ({
      ...base,
      height: 34,
      padding: "0 3px",
    }),

    dropdownIndicator: (base) => ({
      ...base,
      padding: "4px",
    }),

    option: (base) => ({
      ...base,
      fontSize: 13,
      padding: "6px 10px",
    }),

    menuList: (base) => ({
      ...base,
      maxHeight: 200,
      overflowY: "auto",
      scrollBehavior: "smooth",
      "::-webkit-scrollbar": {
        width: "8px",
      },
      "::-webkit-scrollbar-track": {
        background: "#f1f1f1",
        borderRadius: "4px",
      },
      "::-webkit-scrollbar-thumb": {
        background: "#c9c9c9",
        borderRadius: "4px",
      },
      "::-webkit-scrollbar-thumb:hover": {
        background: "#888",
      },
    }),

    menuPortal: (base) => ({
      ...base,
      zIndex: 9999,
    }),

    menu: (base) => ({
      ...base,
      zIndex: 9999,
    }),

    multiValue: (base) => ({
      ...base,
      backgroundColor: "#3b82f6",
      color: "white",
      fontSize: 12,
    }),

    multiValueLabel: (base) => ({
      ...base,
      color: "white",
      fontWeight: 500,
    }),

    multiValueRemove: (base) => ({
      ...base,
      color: "white",
      ":hover": {
        backgroundColor: "#ef4444",
        color: "white",
      },
    }),
  };


  return (
    <>
      <div className="d-flex  justify-content-between align-items-center mb-3 flex-wrap">
        <div>
          <h2 className="mb-2 mb-md-0" style={{ fontSize: "1.5rem" }}>
            Import Data Of{" "}
            <span style={{ textTransform: "capitalize" }}>
              {data?.module_name}
            </span>
          </h2>
          <p>List of current shifts within your organization.</p>
        </div>

        <div className="d-flex align-items-center gap-2">
          {/* Back Button */}
          <div
            className="btn btn-default-outline"
            onClick={() => {
              navigate(-1);
            }}
          >
            <BsArrowLeft className="me-1" /> Back
          </div>
        </div>
      </div>
      <div className="container-fluid d-flex flex-column p-3 create-shift-container mb-5 ">
        {currentStep === 1 && (
          <>
            {loading ? (
              <Loader />
            ) : (
              <>
                {/* Added Step Count Header */}
                <div
                  style={{ alignSelf: "center", width: "45%" }}
                  className="d-flex justify-content-between align-items-center mb-3"
                >
                  <span></span>
                  <span className="badge bg-light text-dark border fw-normal">
                    Step 1 of 3
                  </span>
                </div>

                <div style={{ alignSelf: "center", width: "45%" }}>
                  <div
                    style={{
                      backgroundColor: "#f7e8f0",
                      padding: "1rem",
                      borderRadius: "8px",
                      border: "2px dashed #7a3a5e",
                    }}
                    className="mb-2"
                  >
                    <div
                      style={{
                        padding: "10px",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        position: "relative",
                        borderRadius: "8px",
                        cursor: "pointer",
                      }}
                      onDrop={handleDrop}
                      onDragOver={(event) => event.preventDefault()}
                    >
                      <>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            marginBottom: "1rem",
                          }}
                        >
                          <div
                            className="shadow-sm d-flex align-items-center justify-content-center"
                            style={{
                              backgroundColor: "white",
                              width: "50px",
                              height: "50px",
                              borderRadius: "50%",
                            }}
                          >
                            <IconCloudDownload stroke={2} />
                          </div>
                          <div>
                            <p style={{ fontSize: "1rem" }}>
                              Drag and drop your files here
                            </p>
                          </div>
                        </div>
                        <input
                          type="file"
                          hidden
                          id="browse"
                          accept=".csv"
                          onChange={(e) => {
                            const file = e.target.files?.[0];
                            if (file) setFiles([file]);
                          }}
                        />
                        <label htmlFor="browse" className="btn btn-default">
                          Browse files
                        </label>
                      </>

                      {files.length > 0 && (
                        <div>
                          <div>
                            {files.map((file, index) => (
                              <div
                                className="d-flex align-items-center  gap-1"
                                key={index}
                              >
                                <p>{file.name}</p>
                                <IconXboxX
                                  stroke={2}
                                  size={18}
                                  style={{ stroke: "red", cursor: "pointer" }}
                                  onClick={() => handleRemoveFile(index)}
                                />
                              </div>
                            ))}
                          </div>
                        </div>
                      )}

                      {files.length > 0 && (
                        <div className="d-flex align-items-center gap-2">
                          <AiOutlineCheckCircle style={{ color: "#6DC24B" }} />
                          <p>{files.length} file(s) selected</p>
                        </div>
                      )}
                    </div>
                  </div>
                  <div>
                    <span
                      className="fs-14"
                      style={{
                        color: "#646464",
                        margin: 0,
                      }}
                    >
                      {" "}
                      Download a{" "}
                      <span
                        style={{ color: "blue", cursor: "pointer" }}
                        onClick={() => { getCompanyRecord(data?.module_name) }}
                      >
                        sample file
                      </span>{" "}
                      and compare it to your import file to ensure you have the
                      file perfect for the import.
                    </span>

                    {data?.module_name === "company" ||
                      data?.module_name === "contact" ? (
                      <div className="d-flex mt-3  w-100">
                        <span
                          className="fs-12"
                          style={{
                            margin: 0,
                            color: "red",
                            textWrap: "nowrap",
                          }}
                        >
                          Duplicate Heading{" "}
                          <span style={{ color: "red" }}>*</span>
                        </span>
                        <div
                          className="d-flex flex-column gap-2"
                          style={{ marginLeft: "10rem" }}
                        >
                          <>
                            {" "}
                            <div className="d-flex gap-4">
                              <div className="d-flex align-items-start gap-2">
                                <Form.Check
                                  type="radio"
                                  className="custom-radio"
                                  onChange={() => setCurrSelected("skip")}
                                  checked={currentSelected === "skip"}
                                  style={{ cursor: "pointer" }}
                                />
                                <div>
                                  <span
                                    style={{
                                      fontSize: "0.86rem",
                                      fontWeight: "500",
                                    }}
                                  >
                                    Skip Duplicates
                                  </span>
                                  <p className="fs-12">
                                    Retains the items and does not import the
                                    duplicates in the import file.
                                  </p>
                                </div>
                              </div>
                            </div>
                            <div className="d-flex gap-4">
                              <div className="d-flex align-items-start gap-2">
                                <Form.Check
                                  type="radio"
                                  checked={currentSelected === "duplicate"}
                                  className="custom-radio"
                                  onChange={() => setCurrSelected("duplicate")}
                                  style={{ cursor: "pointer" }}
                                />
                                <div>
                                  <span
                                    style={{
                                      fontSize: "0.86rem",
                                      fontWeight: "500",
                                    }}
                                  >
                                    Overwrite Items
                                  </span>
                                  <p className="fs-12">
                                    Imports the duplicate in the import file and
                                    overwrites the existing items.
                                  </p>
                                </div>
                              </div>
                            </div>
                          </>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                  <div
                    className="d-flex justify-content-between "
                    style={{ marginTop: "8rem" }}
                  >
                    <Button
                      className="btn btn-default-outline"
                      onClick={() => navigate(-1)}
                    >
                      Cancel
                    </Button>
                    <Button
                      className="btn btn-default d-flex align-items-center gap-2"
                      disabled={files.length === 0 || fetchingStatus}
                      onClick={async () => {
                        if (currentStep === 1 && files.length > 0) {
                          const success = await handleUploadFile(files[0]);
                          if (!success) return;
                        }
                        setCurrStep((prev) => prev + 1);
                      }}
                    >
                      {fetchingStatus ? (
                        <>
                          <span
                            className="spinner-border spinner-border-sm"
                            role="status"
                            aria-hidden="true"
                          />
                          Uploading...
                        </>
                      ) : (
                        "Next"
                      )}
                    </Button>
                  </div>
                </div>
              </>
            )}
          </>
        )}
        {currentStep === 2 && (
          <>
            {loading ? (
              <Loader />
            ) : (
              <div
                className="mx-auto"
                style={{ maxWidth: "850px", paddingBottom: "2rem" }}
              >
                {/* Context Header */}
                <div className="d-flex align-items-center justify-content-between mb-4">
                  <span className="fs-14 text-muted">
                    Selected file:{" "}
                    <strong className="text-primary">{files[0].name}</strong>
                  </span>
                  <span className="badge bg-light text-dark border fw-normal">
                    Step 2 of 3
                  </span>
                </div>

                {/* Info Alert - Soft Blue */}
                <div
                  className="d-flex align-items-center gap-2 mb-4 p-3"
                  style={{
                    backgroundColor: "#f0f7ff",
                    borderLeft: "4px solid #007bff",
                    borderRadius: "4px",
                    color: "#2c5282",
                  }}
                >
                  <IconExclamationCircle size={18} />
                  <span className="fs-14 fw-500">
                    The best match for each field has been automatically
                    selected based on your column headers.
                  </span>
                </div>

                {/* Data Format Configuration - Minimalist */}
                <div className="mb-4 p-3 border rounded shadow-sm bg-white">
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <h6
                      className="mb-0 fs-14 fw-bold text-uppercase text-muted"
                      style={{ letterSpacing: "0.5px" }}
                    >
                      Default Data Formats
                    </h6>
                    <button className="btn btn-link btn-sm text-decoration-none p-0 fs-13">
                      <IconPencil size={14} className="me-1" /> Edit
                    </button>
                  </div>
                  <div className="d-flex gap-5">
                    <div>
                      <label className="d-block fs-12 text-muted mb-1">
                        Date Format
                      </label>
                      <span className="fs-14 fw-500">
                        Automatic (per field)
                      </span>
                    </div>
                    <div>
                      <label className="d-block fs-12 text-muted mb-1">
                        Decimal Separator
                      </label>
                      <span className="fs-14 fw-500">
                        Standard (123,456.78)
                      </span>
                    </div>
                  </div>
                </div>

                {/* Mapping Sections */}
                {fieldGroups.map((group) => (
                  <div key={group.key} className="mb-4">
                    {/* Group Title */}
                    <h6
                      className="fs-15 fw-bold mb-3"
                      style={{ color: "#334155" }}
                    >
                      {group.title}
                    </h6>

                    {/* Table Container */}
                    <div className="border rounded bg-white shadow-sm ">
                      {/* Mapping Table Header */}
                      <div
                        className="d-flex bg-light p-2 border-bottom text-muted fw-bold"
                        style={{ fontSize: "11px", letterSpacing: "0.05rem" }}
                      >
                        <div style={{ width: "45%", paddingLeft: "10px" }}>
                          SYSTEM FIELD
                        </div>
                        <div style={{ width: "55%", paddingLeft: "10px" }}>
                          IMPORT AS COLUMN
                        </div>
                      </div>

                      {/* Mapping Rows */}
                      {group.fields.map((field, index) => (
                        <div
                          key={field.id}
                          id={`${group.key}-${field.id}`}
                          className={`d-flex align-items-center p-2 ${index !== group.fields.length - 1
                              ? "border-bottom"
                              : ""
                            }`}
                          style={{ transition: "background-color 0.2s" }}
                          onMouseEnter={(e) =>
                            (e.currentTarget.style.backgroundColor = "#fcfcfc")
                          }
                          onMouseLeave={(e) =>
                          (e.currentTarget.style.backgroundColor =
                            "transparent")
                          }
                        >
                          <div
                            style={{ width: "45%", paddingLeft: "10px" }}
                            className={`fs-14 ${field.required && "text-danger"
                              } fw-500`}
                          >
                            {field.label}{" "}
                            {field.required && (
                              <span className="text-danger">*</span>
                            )}
                          </div>
                          <div style={{ width: "55%" }}>
                            <Select
                              options={getFilteredOptions(index)}

                              styles={customSelectStyles}
                              value={mapping[group.key]?.[field.id] || null}
                              onChange={(selected) => {
                                handleChange(group.key, field.id, selected);
                                setErrors((prev) => ({
                                  ...prev,
                                  [group.key]: {
                                    ...(prev[group.key] || {}),
                                    [field.id]: false,
                                  },
                                }));
                              }}
                              isClearable
                              placeholder="Choose column..."

                            />
                            {errors[group.key]?.[field.id] && (
                              <p
                                style={{
                                  color: "red",
                                  fontSize: "12px",
                                  margin: "4px 0 0 10px",
                                }}
                              >
                                This field is required
                              </p>
                            )}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                ))}

                {/* Navigation Footer */}
                <div className="d-flex justify-content-between align-items-center mt-5 pt-4 border-top">
                  <Button
                    className="px-4 fs-14 btn btn-default"
                    onClick={() => setCurrStep(1)}
                  >
                    Previous Step
                  </Button>
                  <div className="d-flex gap-2">
                    <Button className="text-muted btn btn-default-outline text-decoration-none fs-14">
                      Cancel
                    </Button>
                    <Button
                      className="px-5 fs-14 fw-500 btn btn-default"
                      onClick={async () => {
                        const result = await handleUploadLabels();
                        if (result) {
                          setImportResult(result);
                          setCurrStep(3);
                        }
                      }}
                    >
                      Next
                    </Button>
                  </div>
                </div>
              </div>
            )}
          </>
        )}
        {currentStep === 3 && (
          <>
            {loading ? (
              <Loader />
            ) : (
              <div
                className="mx-auto"
                style={{ minWidth: "900px", maxWidth: "900px" }}
              >
                <div
                  className="d-flex align-items-center gap-2 mb-4 p-3"
                  style={{
                    backgroundColor: "#fff8e1",
                    borderLeft: "4px solid #ffb300",
                    borderRadius: "4px",
                    color: "#8a6d3b",
                  }}
                >
                  {currentSelected === "skip" ? (
                    <>
                      <IconExclamationCircle size={18} />
                      <span className="fs-14 fw-500">
                        Data will be skipped on the basis of Email and Phone
                        Number.
                      </span>
                    </>
                  ) : (
                    <>
                      <div className="d-flex flex-column w-100">
                        <span className="fs-14 fw-500 mb-2 d-flex align-items-center gap-1 justify-content-start ">
                          <IconExclamationCircle size={18} />
                          Overwrite will occur based on the selected matching
                          column.
                        </span>
                        <Select
                          options={fileHeaders.map((h) => ({
                            value: h.value,
                            label: h.label,
                          }))}
                          placeholder="Select matching column..."
                          styles={{
                            placeholder: (base) => ({
                              ...base,
                              marginLeft: "10px",
                            }),
                            singleValue: (base) => ({
                              ...base,
                              marginLeft: "10px",
                            }),
                            control: (base) => ({
                              ...base,
                              width: "425px",
                              minHeight: "36px",
                              borderRadius: "6px",
                              border: "1px solid #e2e8f0",
                              boxShadow: "none",
                              fontSize: "13px",
                              "&:hover": { borderColor: "#cbd5e0" },
                            }),
                            menu: (base) => ({
                              ...base,
                              width: "425px",
                              fontSize: "13px",
                              zIndex: 9999,
                              maxHeight: "10rem",
                              overflow: "auto",
                            }),
                            menuList: (base) => ({
                              ...base,
                              color: "black",
                            }),
                          }}
                          onChange={(selected) =>
                            setOverwriteColumn(selected?.value)
                          }
                        />
                      </div>
                    </>
                  )}
                </div>
                <h4 className="mb-3">Preview</h4>

                <Accordion defaultActiveKey={["0"]} alwaysOpen>
                  <Accordion.Item
                    className="sales-order-accordion"
                    eventKey="0"
                  >
                    <Accordion.Header>
                      {importResult?.importing_data?.length > 0 && (
                        <i className="bi bi-exclamation-circle-fill text-warning me-2"></i>
                      )}
                      Imported Data
                    </Accordion.Header>
                    <Accordion.Body>
                      {importResult?.importing_data?.length > 0 ? (
                        <div style={{ overflowX: "auto" }}>
                          <table
                            className="table table-bordered"
                            style={{ minWidth: "600px" }}
                          >
                            <thead>
                              <tr>
                                {importResult?.label?.map((lbl) => (
                                  <th
                                    key={lbl}
                                    style={{ textTransform: "capitalize" }}
                                  >
                                    {lbl.replace(/_/g, " ")}
                                  </th>
                                ))}
                              </tr>
                            </thead>
                            <tbody>
                              {importResult?.importing_data?.map((row, idx) => (
                                <tr key={idx}>
                                  {row?.map((col, i) => (
                                    <td key={i}>{col}</td>
                                  ))}
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      ) : (
                        <p>No imported data available.</p>
                      )}
                    </Accordion.Body>
                  </Accordion.Item>

                  <Accordion.Item
                    className="sales-order-accordion"
                    eventKey="1"
                  >
                    <Accordion.Header>
                      <div className="d-flex align-items-center gap-2 w-100 justify-content-between">
                        <div className="d-flex align-items-center gap-2">
                          {importResult?.skipped_data?.length > 0 && (
                            <i className="bi bi-exclamation-circle-fill text-warning me-2"></i>
                          )}
                          Skipped Data
                        </div>

                        {importResult?.skipped_data?.length > 0 && (
                          <span
                            className="text-primary d-flex align-items-center"
                            style={{
                              fontSize: "12px",
                              cursor: "pointer",
                              fontWeight: 500,
                              marginRight: "1rem",
                            }}
                            disabled={importResult?.skipped_data?.length > 0}
                            onClick={(e) => {
                              e.stopPropagation();
                              downloadCSV(
                                data?.module_name,
                                importResult?.skipped_data
                              );
                            }}
                          >
                            <IconDownload size={16} stroke={2} />
                            Download CSV
                          </span>
                        )}
                      </div>
                    </Accordion.Header>
                    <Accordion.Body>
                      {importResult?.skipped_data?.length > 0 ? (
                        <div style={{ overflowX: "auto" }}>
                          <table
                            className="table table-bordered"
                            style={{ minWidth: "600px" }}
                          >
                            <thead>
                              <tr>
                                {importResult.label?.map((lbl) => (
                                  <th
                                    key={lbl}
                                    style={{ textTransform: "capitalize" }}
                                  >
                                    {lbl.replace(/_/g, " ")}
                                  </th>
                                ))}
                              </tr>
                            </thead>
                            <tbody>
                              {importResult.skipped_data?.map((row, idx) => (
                                <tr key={idx}>
                                  {row.map((col, i) => (
                                    <td key={i}>{col}</td>
                                  ))}
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      ) : (
                        <p>No skipped rows available.</p>
                      )}
                    </Accordion.Body>
                  </Accordion.Item>

                  <Accordion.Item
                    className="sales-order-accordion"
                    eventKey="2"
                  >
                    <Accordion.Header>
                      {importResult?.reject?.length > 0 && (
                        <i className="bi bi-exclamation-circle-fill text-warning me-2"></i>
                      )}
                      Rejected Data
                    </Accordion.Header>
                    <Accordion.Body>
                      {importResult?.reject?.length > 0 ? (
                        <div style={{ overflowX: "auto" }}>
                          <table
                            className="table table-bordered"
                            style={{ minWidth: "600px" }}
                          >
                            <thead>
                              <tr>
                                {importResult.label?.map((lbl) => (
                                  <th
                                    key={lbl}
                                    style={{ textTransform: "capitalize" }}
                                  >
                                    {lbl.replace(/_/g, " ")}
                                  </th>
                                ))}
                                <th>REJECT REASON</th>
                              </tr>
                            </thead>
                            <tbody>
                              {importResult.reject?.map((row, idx) => (
                                <tr key={idx}>
                                  {row.slice(0, -1).map((col, i) => (
                                    <td key={i}>{col}</td>
                                  ))}
                                  <td>{row[row.length - 1]}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      ) : (
                        <p>No rejected rows.</p>
                      )}
                    </Accordion.Body>
                  </Accordion.Item>

                  <Accordion.Item
                    className="sales-order-accordion"
                    eventKey="3"
                  >
                    <Accordion.Header>
                      <div className="d-flex align-items-center gap-2">
                        <span>
                          <i className="bi bi-exclamation-triangle-fill text-warning ps-1"></i>{" "}
                          Unmapped Fields -{" "}
                        </span>
                        <p style={{ fontWeight: 500, color: "#ffbd06" }}>
                          {unmappedCount}
                        </p>
                      </div>
                    </Accordion.Header>
                    <Accordion.Body>
                      {importResult?.unmapped?.length > 0 ? (
                        <pre>
                          {JSON.stringify(importResult.unmapped, null, 2)}
                        </pre>
                      ) : (
                        <p>No unmapped fields.</p>
                      )}
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>

                <div className="d-flex justify-content-between align-items-center mt-5 pt-4 border-top">
                  <Button
                    className="px-4 fs-14 btn btn-default"
                    onClick={() => setCurrStep(2)}
                  >
                    Previous Step
                  </Button>
                  <div className="d-flex gap-2">
                    <Button className="text-muted btn btn-default-outline text-decoration-none fs-14">
                      Cancel
                    </Button>
                    <Button
                      className="px-5 fs-14 fw-500 btn btn-default"
                      disabled={!importResult?.importing_data?.length}
                      onClick={async () => {
                        await handleFinalImport();
                      }}
                    >
                      Import
                    </Button>
                  </div>
                </div>
              </div>
            )}
          </>
        )}
        <style jsx>
          {`
            .custom-radio .form-check-input {
              height: 21px;
              background-color: var(--custom-white);
              border: 1px solid var(--input-border);
            }
            .custom-radio .form-check-input:checked {
              height: 21px;
              background-color: var(--primary-color);
              border-color: var(--primary-color);
            }
          `}
        </style>
      </div>
    </>
  );
};
